import request from '@/utils/request';
import Resource from '@/api/resource';
class ChannelPackageResource extends Resource {
  constructor() {
    super('tool/androidUnionChannelPackage/gdt');
  }

  /** 获取渠道分类接口 */
  getChannelPackageApi(data) {
    return request({
      url: `/${this.uri}`,
      method: 'get',
      params: data,
    });
  }

  /** 更新渠道分类接口 */
  pullChannelPackageApi(data) {
    return request({
      url: `/${this.uri}/pull`,
      method: 'get',
      params: data,
    });
  }

  /** 批量创建广告渠道接口 */
  addChannelPackageApi(data) {
    return request({
      url: `/${this.uri}/batchAdd`,
      method: 'POST',
      data,
    });
  }
}
export { ChannelPackageResource as default };
